import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';

import { ModifierInformation } from './utils';

interface IMissingModifierSelectionCtaProps {
  modifierInformation: ModifierInformation;
}

export const MissingModifierSelectionCta = ({
  modifierInformation,
}: IMissingModifierSelectionCtaProps) => {
  const { formatMessage } = useIntl();

  const buttonLabel = useMemo(() => {
    const { modifier, modifierRemainingSelections, modifierQuantity } = modifierInformation;

    const modifierMaxAmount = modifierQuantity?.max ?? 0;
    const modifierMinAmount = modifierQuantity?.min ?? 0;
    const noSelectionsYet = modifierRemainingSelections === modifierMinAmount;
    if (noSelectionsYet) {
      const itemName = formatMessage({ id: modifierMaxAmount > 1 ? 'options' : 'option' });
      return formatMessage({ id: 'selectUpTo' }, { amount: modifierMaxAmount, itemName });
    }

    const isModifierMultipleChoice = modifierMaxAmount > 1;
    if (isModifierMultipleChoice) {
      return formatMessage({ id: 'selectRemaining' }, { amount: modifierRemainingSelections });
    }

    // TODO: evaluate which menu object trigger this case
    const modifierName = modifier.name?.locale ?? '';
    return formatMessage(
      { id: 'selectSingleChoice' },
      { amount: modifierRemainingSelections, itemName: modifierName }
    );
  }, [formatMessage, modifierInformation]);

  return (
    <ActionButton testID="product-home-action-button" disabled flex={1}>
      {buttonLabel}
    </ActionButton>
  );
};
